
import { Suspense } from 'react';
import { OrbitControls } from '@react-three/drei';
import { Cat } from './Cat';
import { Canvas,useFrame} from '@react-three/fiber';
import { useRef } from 'react';
import {React} from 'react';
let rotationY = 0.003;

const Model3D = () => {
    return (
        <div className='model3d'>
         <Canvas onMouseDown={()=>rotationY = 0} onMouseUp={()=> rotationY = 0.003}>
          <OrbitControls  infinite={true} enableZoom={false} enablePan={false} />
            <Rotate>
              <ambientLight intensity={1}/>
                <pointLight  color="pink"  position={[5, 5, 5]} />
                <Suspense fallback={null}>
                <Cat />
              </Suspense>
            </Rotate>
          </Canvas>
        
        </div>
      );
    }

  const Rotate = (props) => {
    const ref = useRef();
    useFrame(() => (ref.current.rotation.y += rotationY ));
    return <mesh ref={ref} {...props} />;
  };
export default Model3D;
